import { createRouter, RouteRecordRaw, createWebHashHistory } from 'vue-router'
import homeRouter from './homeRouter'
import adminRouter from './adminRouter'
import { userPinia } from '@/store/user'
import { authPinia } from '@/store/auth'
import getRoleAuth from '@/setup/getRoleAuth'
import { getCookie } from '@/utils/cookie'
import { ExpenseAuth, ManageAuth } from '@/interface/api/role'
// import { message } from 'ant-design-vue'
import authToPath from './authToPath'
import { CommonType } from '@/interface'
const routes: RouteRecordRaw[] = [
  homeRouter,
  adminRouter,
  {
    path: '/login',
    component: () => import('@/views/account-login.vue'),
    meta: { title: '登录', noLogin: true }
  },
  {
    path: '/scanCode',
    component: () => import('@/views/scancode-entry.vue'),
    meta: { title: '开票信息录入', noLogin: true }
  },
  {
    path: '/scancodeInvoice',
    component: () => import('@/views/scancode-invoice.vue'),
    meta: { title: '开票信息录入', noLogin: true }
  },
  {
    path: '/invoice-download',
    component: () => import('@/views/invoice-download.vue'),
    meta: { title: '发票下载', noLogin: true }
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    // vue-router4 通配符方式
    path: '/:w+',
    redirect: '/home'
  }
]
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const user = userPinia()
  const token = user.token || sessionStorage.getItem('access-engine-token')
  if (!user.token && token) {
    user.login(token)
    const firstLogin = getCookie('first-login')
    user.setFirstLogin(firstLogin)
  }
  const authInfo = authPinia()
  const { getAuth } = getRoleAuth()
  if (to.meta.noLogin) {
    next()
  } else {
    if (token) {
      if (!authInfo.auth) {
        await getAuth()
      }
      const { meta, path } = to
      const auth = meta.auth as string | undefined
      let redirectUrl = ''
      // console.log(auth)
      if (auth) {
        const authArr: string[] = auth.split('.')
        const isHome = path.split('/')[1] === 'home'
        let curAuth: CommonType | null = null
        authArr.forEach((d) => {
          if (curAuth) {
            curAuth = curAuth[d]
          } else {
            if (isHome) {
              curAuth = authInfo.piaoshuiAuth?.[d as keyof ExpenseAuth] || null
            } else {
              curAuth = authInfo.manageAuth?.[d as keyof ManageAuth] || null
            }
          }
        })
        if (isHome) {
          // 当前页面为首页
          if (!(authInfo.piaoshuiAuth && curAuth)) {
            redirectUrl = '/home'
          }
        } else {
          // 当前页面为后台页面
          if (!(authInfo.manageAuth && curAuth)) {
            const key: keyof ManageAuth | string = authInfo.manageAuth ? Object.keys(authInfo.manageAuth)[0] : ''
            redirectUrl = key ? authToPath[key as keyof ManageAuth] || '/admin/firm-lists' : '/home'
          }
        }
      }
      if (redirectUrl) {
        next({
          path: redirectUrl
        })
      } else {
        next()
      }
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  }
})

export default router
